export default __webpack_public_path__ + "static/media/Complete1.1370ffd0.svg";